import React from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import PqiImg from '../../img/pqi_img.png';
import PdiImg from '../../img/pdi_img.png';
import PsiImg from '../../img/psi_img.png';
import IqiImg from '../../img/iqi_img.png';
import styles from './home.module.scss';
import { Link } from 'react-router-dom';

const HomeExplore = () => {
    return (<>
        <Container className={styles.mainContainer}>
            <div>
                <h3 className={'centerText' + ' ' + 'mb-4'}>Explore the Quality Indicators</h3>
                <Row>
                    <Col xs={12} md={6} className={styles.stretchCard}>
                        <Card className="mb-4">
                            <Card.Img variant="top" src={PqiImg} />
                            <Card.Body>
                                <Card.Title>Prevention Quality Indicators (PQI)</Card.Title>
                                <Card.Text>
                                    The PQIs are area-level Indicators that calculate admissions that might have been avoided through access to high-quality outpatient care and are a key tool for community health needs assessments.
                                </Card.Text>
                            </Card.Body>
                            <div className={styles.cardBtn}>
                                <Link
                                    className="btn btn-primary"
                                    role="button"
                                    to="/measures/pqi_resources"
                                >Learn More</Link>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={12} md={6} className={styles.stretchCard}>
                        <Card className="mb-4">
                            <Card.Img variant="top" src={IqiImg} />
                            <Card.Body>
                                <Card.Title>Inpatient Quality Indicators (IQI)</Card.Title>
                                <Card.Text>
                                    The IQIs include mortality indicators, utilization indicators, and volume indicators for key procedures to help hospitals identify potential problem areas that might need further study, as well as for quality improvement and trending initiatives.
                                </Card.Text>
                            </Card.Body>
                            <div className={styles.cardBtn}>
                                <Link
                                    className="btn btn-primary"
                                    role="button"
                                    to="/measures/iqi_resources"
                                >Learn More</Link>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} className={styles.stretchCard}>
                        <Card xs={12} sm={12} md={12} className="mb-4">
                            <Card.Img variant="top" src={PsiImg} />
                            <Card.Body>
                                <Card.Title>Patient Safety Indicators (PSI)</Card.Title>
                                <Card.Text>
                                    The PSIs reflect potentially avoidable safety events that represent opportunities for improvement in the delivery of care.
                                </Card.Text>
                            </Card.Body>
                            <div className={styles.cardBtn}>
                                <Link
                                    className="btn btn-primary"
                                    role="button"
                                    to="/measures/psi_resources"
                                >Learn More</Link>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={12} md={6} className={styles.stretchCard}>
                        <Card className="mb-4">
                            <Card.Img variant="top" src={PdiImg} />
                            <Card.Body>
                                <Card.Title>Pediatric Quality Indicators (PDI)</Card.Title>
                                <Card.Text>
                                    The PDIs are specifically tailored to reflect the special characteristics of the pediatric population, including neonates, and can be used to identify potential quality and patient safety issues specific to the pediatric inpatient population.
                                </Card.Text>
                            </Card.Body>
                            <div className={styles.cardBtn}>
                                <Link
                                    className="btn btn-primary"
                                    role="button"
                                    to="/measures/pdi_resources"
                                >Learn More</Link>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Container>
    </>)
}

export default HomeExplore;